import BudgetProgressReport from '@/api/BudgetProgressReport/BudgetProgressReport'
import C3Wrapper from '@/middlewares/C3Wrapper/C3Wrapper'

const actions = {
  async GET_INITIAL_TABLE_DATA({ commit, dispatch }, { advertiserId }) {
    dispatch('GET_BP_LIST', { advertiserId })
    const middleLang = await BudgetProgressReport.getInitialMiddleLangInitial({
      advertiserId,
    })

    const query = BudgetProgressReport.middleLangToQuery({ middleLang })

    // table のデータ
    const res = await BudgetProgressReport.fetchIOProgress({
      advertiserId,
      ...query,
      dimensionType: 'total',
    })

    const data = res.data
    const today = res.today

    // chart
    if (data.length !== 0) {
      // データがあるときだけグラフを描画する
      const Id = data[0].insertionOrderId
      // 単に UI を変更, 選ばれている IO のラジオボタン
      dispatch('CHANGE_SELECTED_IO_ID', { Id })
      commit('SET_TABLE_DATA', { data })
      commit('SET_TODAY', { today })
      commit('SET_MIDDLE_LANG', { middleLang })
      const payload = { IOId: Id, advertiserId }
      dispatch('CHANGE_CHART', payload)
    }

    return data
  },

  async CHANGE_BP({ state, commit, dispatch }, { IOId, BPId, advertiserId }) {
    const middleLang = state.middleLang
    // 重複選択を一回許容
    // const valid = BudgetProgressReport.bpChangeValid({ middleLang, IOId, BPId })
    // if (!valid) return
    const newMiddleLang = BudgetProgressReport.changeMiddleLang({
      middleLang,
      IOId,
      BPId,
    })
    const query = BudgetProgressReport.middleLangToQuery({
      middleLang: newMiddleLang,
    })
    const res = await BudgetProgressReport.fetchIOProgress({
      advertiserId,
      ...query,
      dimensionType: 'total',
    })

    const data = res.data
    const today = res.today

    commit('SET_TABLE_DATA', { data })
    commit('SET_MIDDLE_LANG', { middleLang })

    // チャートデータも変更するアクション
    commit('SET_TODAY', { today })
    dispatch('CHANGE_CHART', { IOId, advertiserId })

    return data
  },
  async CHANGE_CHART({ state, commit, dispatch }, { IOId, advertiserId }) {
    dispatch('CHANGE_SELECTED_IO_ID', { Id: IOId })
    const middleLang = state.middleLang

    // fixnakanishi 本当はここで二度手間な更新になっていないか確認すべき
    // const valid = BudgetProgressReport.bpChangeValid({ middleLang, IOId, BPId })
    // if (!valid) return

    const filteredMiddleLang = middleLang.filter(o => o.IOId === IOId)
    const query = BudgetProgressReport.middleLangToQuery({
      middleLang: filteredMiddleLang,
    })

    const res = await BudgetProgressReport.fetchIOProgress({
      advertiserId,
      ...query,
      dimensionType: 'daily',
    })

    const data = res.data

    // BP 割り出し
    const [selectedIO] = middleLang.filter(IO => {
      return IO.IOId === IOId
    })

    const [selected] = selectedIO.BPIds.filter(BPId => BPId.selected)

    // today 割り出し
    const today = state.today

    // 目標予算割り出し
    const targetIO = state.tableData.find(o => o.insertionOrderId === IOId)

    if (targetIO) {
      const targetBudget = targetIO.dailyBuyingCurrencyPlan

      const progressData = C3Wrapper.makeProgressData({
        data,
        targetBudget,
        today: today,
        bpStart: selected.startTime,
        bpEnd: selected.endTime,
      })

      commit('SET_CHART_DATA', { data: progressData })
      return data
    } else {
      // レポートデータが無い場合、グラフをクリアする
      commit('SET_CHART_DATA', { data: [] })
    }
  },

  CHANGE_SELECTED_IO_ID({ commit }, { Id }) {
    commit('SET_SELECTED_IO_ID', { Id })
  },

  async GET_BP_LIST({ commit }, { advertiserId }) {
    const BPList = await BudgetProgressReport.getBPList({ advertiserId })
    commit('SET_BP_LIST', { BPList })
  },
}

export default actions
